import React, {Component} from 'react'
//import Man from '../../assets/images/Man.svg'

class LoaderLogo extends Component{

    render(){
        const {width,height,fill='#000'}=this.props
        return(
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"x="0px" y="0px"
            viewBox="0 0 83.6 72.4">
        <title>LOGO_01</title>
        <path class="st0-loader" d="M40.8,16.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8h27.1c1,0,1.9,0.5,2.3,1.4l0,0l13.1,22.8
            c0.7,1.4,0.1,3-1.2,3.7c-1.2,0.6-2.7,0.2-3.5-0.9L66.3,16.1L40.8,16.2L40.8,16.2z"/>
        <path class="st0-loader" d="M59.8,24.7c-0.8-1.3-0.5-3,0.8-3.8s3-0.5,3.8,0.8c0.1,0.1,0.1,0.2,0.2,0.3l5.8,10l0.1,0.2l7.7,13.4
            c0.5,0.9,0.5,1.9,0,2.8l-7.8,13.4l0,0L64.9,71c-0.7,1.4-2.3,1.9-3.7,1.2c-1.4-0.7-1.9-2.3-1.2-3.7c0.1-0.1,0.1-0.2,0.2-0.3l5.3-9.3
            l0,0l7-12.1l-6.9-12v-0.2L59.8,24.7z"/>
        <path class="st0-loader" d="M61.2,44.8c0.8-1.3,2.6-1.6,3.8-0.8c1.1,0.8,1.5,2.3,0.9,3.5l-5.8,10L60,57.6L52.4,71c-0.5,0.9-1.4,1.4-2.4,1.4
            H23.8c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8h24.7l6.9-12l0.1-0.2L61.2,44.8z"/>
        <path class="st0-loader" d="M43,56.2c1.5,0,2.8,1.2,2.8,2.8s-1.2,2.8-2.8,2.8H15.9c-1,0-1.9-0.6-2.4-1.4L5.7,46.8l0,0l-5.4-9.3
            c-0.7-1.4-0.1-3,1.2-3.7c1.2-0.6,2.7-0.2,3.5,0.9l5.3,9.3l0,0l7,12.1L43,56.2L43,56.2z"/>
        <path class="st0-loader" d="M24,47.6c0.8,1.3,0.3,3-1,3.8s-3,0.3-3.8-1l0,0L5.7,26.9c-0.5-0.8-0.5-1.9,0-2.7l0,0L18.9,1.4
            c0.8-1.3,2.6-1.6,3.8-0.8c1.1,0.8,1.5,2.3,0.9,3.5L11.2,25.5L24,47.6z"/>
        <path class="st0-loader" d="M22.5,27.6c-0.7,1.4-2.3,1.9-3.7,1.2c-1.4-0.7-1.9-2.3-1.2-3.7c0.1-0.1,0.1-0.2,0.2-0.3L31.3,1.4
            C31.8,0.5,32.7,0,33.7,0H60c1.5,0,2.8,1.2,2.8,2.8S61.5,5.5,60,5.5H35.2L22.5,27.6z"/>
        </svg>
        )
    }    
}

export default LoaderLogo


// WEBPACK FOOTER //
// ./src/components/Svgs/LoaderLogo.js